import React from "react";

// Dot colors are in src/components/data-display/styles/tabs/tabs.scss
type DotColor = "red" | "yellow" | "orange";

interface TabLabelProps {
  showDot: boolean;
  dotColor: DotColor;
  children: React.ReactNode;
}

export const TabLabel = ({ showDot, children, dotColor }: TabLabelProps) => (
  <div className="tab-label">
    {children}
    {showDot && <span className={`dot ${dotColor}`} />}
  </div>
);
